export default {
  props: {
    thumbnail: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      mediaLoaded: false
    }
  },

  methods: {
    emitMediaLoaded () {
      this.mediaLoaded = true

      this.$emit('mediaLoaded')
    }
  }
}
